import { Component, OnInit,Input,EventEmitter,Output } from '@angular/core';
import { RemoteUsersService } from '../../services/remote-users/remote-users.service';
import { Subscription } from 'rxjs';
import { UserModel } from '../../models/user-model';
import { remoteUserConnection } from '../../../_models/addVideo';
import { OpenViduWebrtcService } from '../../services/openvidu-webrtc/openvidu-webrtc.service';
import { ChatService } from '../../services/chat/chat.service';
@Component({
  selector: 'app-right-menu',
  templateUrl: './right-menu.component.html',
  styleUrls: ['./right-menu.component.css']
})
export class RightMenuComponent implements OnInit {
  @Input() lightTheme: boolean;
  @Input() reciveFromParent: any;
  @Output() outPutToParent = new EventEmitter<any>();
  private remoteUsersSubscription: Subscription;
  remoteUsersForPart: UserModel[] = [];
  remoteUsers: UserModel[] = [];
  remoteUserConnectionID: remoteUserConnection;
  changeText:boolean=false;

 isView:any = [];

 isShowRemoteControls:any=[];
 
 isMute:any = [];
 priviousVideoViewingID:any=String;
 cureentVideoViewingID:any=String;
  raiseHandUserList = [];
  constructor(
    private remoteUsersService: RemoteUsersService,
    private openViduWebRTCService: OpenViduWebrtcService,
    private chatService: ChatService,
    
  ) { 
    this.isView = {};
    this.isMute = {};
    this.isShowRemoteControls = {};
    

  }

  ngOnInit(): void {
    
   this.subscribeToRaiseHands();
    this.remoteUsersSubscription = this.remoteUsersService.remoteUsers.subscribe((users: UserModel[]) => {
      this.remoteUsers = [];
      this.remoteUsers = [...users];
      this.remoteUsersForPart = [];
      console.log(this.remoteUsers.length);
      for(let i=0;i<this.remoteUsers.length;i++)
			{
				var connID = this.remoteUsers[i].connectionId;
				var str = this.remoteUsers[i].nickname;
				var myStr = str.split('_');
				var usID = myStr[0].toString();
				console.log('sandeep'+usID);
			
				
					this.remoteUsersForPart.push(this.remoteUsersService.getRemoteUserByConnectionId(connID));
					//console.log('sandeep'+);
		
			}



    });
  }
setRemoteUserConnectionID(value,connectionID)
{

  this.priviousVideoViewingID = this.cureentVideoViewingID;

  this.cureentVideoViewingID=connectionID;
  if(this.priviousVideoViewingID != '')
  {
    this.sendMessageForreconnectPriviousUser(this.priviousVideoViewingID);
  }
  this.sendMessageForreconnectUser(this.cureentVideoViewingID);

this.isView[value]=!this.isView[value];
this.outPutToParent.emit(connectionID);
}
sendMessageForForceDisconnect(message: string) {
  message = message;
  
    const data = {
      message: message
    };
    var myArray = [];
    myArray.push(message);
    const sessionAvailable = this.openViduWebRTCService.getSessionOfUserConnected();
    sessionAvailable.signal({
      to:[],
      data: JSON.stringify(data),
      type: 'removeUser'
    });
  
}
sendMessageForAllSubscriber() {
  let message = 'All';
  
    const data = {
      message: message
    };
    var myArray = [];
    myArray.push(message);
    const sessionAvailable = this.openViduWebRTCService.getSessionOfUserConnected();
    sessionAvailable.signal({
      to:[],
      data: JSON.stringify(data),
      type: 'signal:allUserSubscriber'
    });
  
}


sendMessageForreconnectPriviousUser(message: string) {
  message = message;
  
    const data = {
      message: message
    };
    var myArray = [];
    myArray.push(message);
    const sessionAvailable = this.openViduWebRTCService.getSessionOfUserConnected();
    sessionAvailable.signal({
      to:[],
      data: JSON.stringify(data),
      type: 'signal:reconnectPriviousUser'
    });
  
}


sendMessageForreconnectUser(message: string) {
  message = message;
  
    const data = {
      message: message
    };
    var myArray = [];
    myArray.push(message);
    const sessionAvailable = this.openViduWebRTCService.getSessionOfUserConnected();
    sessionAvailable.signal({
      to:[],
      data: JSON.stringify(data),
      type: 'signal:reconnectUser'
    });
  
}


sendMessageForRaiseHand() {
  let message = 'raiseHand';
  
    const data = {
      message: message
    };
    var myArray = [];
    myArray.push(message);
    const sessionAvailable = this.openViduWebRTCService.getSessionOfUserConnected();
    sessionAvailable.signal({
      to:[],
      data: JSON.stringify(data),
      type: 'raiseHand'
    });
  
}
sendMessageForMute(messageNew) {
 // this.isMute[messageNew]=!this.isView[messageNew];
  let message = messageNew;
  
    const data = {
      message: message
    };
    var myArray = [];
    myArray.push(message);
    const sessionAvailable = this.openViduWebRTCService.getSessionOfUserConnected();
    sessionAvailable.signal({
      to:[],
      data: JSON.stringify(data),
      type: 'muteUser'
    });
   
}

private subscribeToRaiseHands() {
  this.chatService.raiseHandID.subscribe((raiseHandID: string) => {
    console.log('raiseHandID');
   console.log(raiseHandID);
   
   this.raiseHandUserList.push(raiseHandID);
 });
}
removeRaiseHand(conID)
{
  const index: number = this.raiseHandUserList.indexOf(conID);
  if (index !== -1) {
    this.raiseHandUserList.splice(index, 1);
} 
}


toggleChat() {
  this.chatService.toggleChat();
}

}
